import React from 'react';
import { Reveal, Eyebrow } from './Section';
import { IMAGES } from './constants';
const items = [{
  image: IMAGES.ebook,
  alt: 'Portada del ebook Tus primeros USD 1.000 con contenido UGC',
  label: 'Ebook completo · 8 módulos',
  desc: 'El método paso a paso, del cero a contactar más de 80 marcas y cobrar en dólares.'
}, {
  image: IMAGES.bonus1,
  alt: 'Bono 1: De cuánto cobrás a cuándo empezás',
  label: 'Bono 1 incluido',
  desc: 'Plantillas y estrategias para presentar precios, negociar y cerrar propuestas con confianza.'
}, {
  image: IMAGES.bonus2,
  alt: 'Bono 2: Hacé tus videos así y conseguí miles de contratos',
  label: 'Bono 2 incluido',
  desc: 'Guía práctica con estructuras, planos, hooks y ejemplos para crear contenido más atractivo.'
}, {
  image: IMAGES.bonus3,
  alt: 'Bono 3: Portafolio UGC más ganador',
  label: 'Bono 3 incluido',
  desc: 'Paso a paso para organizar tus muestras y presentar tus servicios de manera profesional.'
}];
export function ValueStack() {
  return <section className="w-full bg-sand/50 py-16 sm:py-24" data-id="element-211" data-mp="1td0f8m6bh5jn">
      <div className="mx-auto max-w-3xl px-5 sm:px-6" data-id="element-212" data-mp="1ohl8sfan2bx9">
        <Reveal className="text-center" data-id="element-213" data-mp="234wi0ajclju7">
          <Eyebrow data-id="element-214" data-mp="235y192aipcn0">Todo lo que te llevás</Eyebrow>
          <h2 className="mt-4 font-display text-3xl font-semibold leading-tight text-plum sm:text-4xl" data-id="element-215" data-mp="1yeg0ae8hvc21">
            El ebook + 3 bonos para acelerar tus resultados
          </h2>
        </Reveal>

        <div className="mt-12 space-y-4" data-id="element-216" data-mp="2849dfjoabz8e">
          {items.map((item, i) => <Reveal key={item.label} delay={i * 0.06} data-id="element-217" data-mp="286c5085360f8" data-mpi={i}>
              <article className="flex flex-col gap-5 rounded-2xl border border-sand bg-white p-4 shadow-card transition-transform duration-300 hover:-translate-y-1 sm:flex-row sm:items-center sm:gap-6 sm:p-5" data-id="element-218" data-mp="2m2zch4uo08ze">
                <img src={item.image} alt={item.alt} className="aspect-[4/5] w-full rounded-xl object-cover shadow-card sm:w-32" data-id="element-219" data-mp="rqsqrc45a9su" />
                <div className="min-w-0 flex-1" data-id="element-220" data-mp="2muqokidbbpqe">
                  <p className="text-xs font-semibold uppercase tracking-[0.16em] text-coral-dark" data-id="element-221" data-mp="2rrz92plxo5ut">
                    {item.label}
                  </p>
                  <p className="mt-2 text-sm leading-relaxed text-ink/70" data-id="element-222" data-mp="2vsau43i7k86t">{item.desc}</p>
                </div>
              </article>
            </Reveal>)}
        </div>

        <Reveal delay={0.1} data-id="element-223" data-mp="35qz023wx4wu5">
          <div className="mt-8 overflow-hidden rounded-2xl bg-plum text-cream shadow-soft" data-id="element-224" data-mp="35rrymhlq4g17">
            <div className="flex flex-col items-center gap-2 p-7 text-center sm:flex-row sm:justify-between sm:text-left" data-id="element-225" data-mp="3apa7y93nkx9q">
              <div data-id="element-226" data-mp="3fk7ffblaayki">
                <p className="text-sm text-cream/70" data-id="element-227" data-mp="3jj6on8e1thhr">Valor total de todo el material</p>
                <p className="font-display text-2xl font-semibold line-through decoration-coral-light decoration-2" data-id="element-228" data-mp="3oij9xop9ugi8">
                  1200 UYU
                </p>
              </div>
              <div className="sm:text-right" data-id="element-229" data-mp="3tf9r6fctbi58">
                <p className="text-sm text-gold-soft" data-id="element-230" data-mp="7h6q1wz9g19h">Hoy con 50% OFF</p>
                <p className="font-display text-4xl font-bold text-coral-light" data-id="element-231" data-mp="2hbxlozu73mb">$599 UYU</p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}